import { error } from 'components/core/Notification';

export default {
  defaultError: error('Something went wrong. Please try again.'),
};
